import React from 'react';
import WelcomeContainer from '../components/welcome.container';

/**
 * Where a signed-in user lands until they turn this page off.
 *
 * Dismissing it is a profile preference, not local state, so it stays dismissed on every device.
 */
const WelcomePage: React.FC = () => <WelcomeContainer />;

export default WelcomePage;
